import { full_keyword_search } from "../utils/full_keyword_search";
import { locationOf } from "../utils/locationOf";
import { QIndexPair } from "./QIndexPair";
import { binary_search_iterative } from "../utils/binary_search_iterative";

export class QGenericIndex {
  constructor() {
    this.fIndex = null;
  }

  InitIndex() {
    this.fIndex = [];
  }

  GetIndexLength() {
    return this.fIndex.length;
  }

  GetObjectByIndex(index) {
    return this.fIndex[index];
  }

  AddToIndex(obj, value) {
    var p = new QIndexPair();
    p.InitPair(obj, value);

    //var l = locationOf(value, this.fIndex);
    if (this.fIndex.length == 0) this.fIndex.push(p);
    else {
      var l = locationOf(value, this.fIndex);
      //findLocationFor(this.fIndex, value);
      this.fIndex.splice(l + 1, 0, p);
    }
  }

  RemoveIndexObj(index) {
    this.fIndex.splice(index, 1);
  }

  FindObjectIndex(value) {
    var p = binary_search_iterative(this.fIndex, value);
    if (p != null) return p;
    return -1;
  }

  FindObject(value) {
    var o = null;
    var p = binary_search_iterative(this.fIndex, value);
    if (p != null) o = this.fIndex[p].fObj;
    return o;
  }

  FindSimilarObject(fieldValue) {
    var o = null;
    fieldValue = String(fieldValue);
    var p = full_keyword_search(this.fIndex, fieldValue);
    if (p != null) o = this.fIndex[p].fObj;

    return o;
  }
}
